import { REQUIRED_FIELD_MESSAGE } from "constants/errorMessages";
import { TWO_SPACE_IN_ROW_REGEX } from "constants/regexes";
import { DirectUploadMedia } from "libs/directUpload";
import * as yup from "yup";

export const categoryName = (fieldName: string) =>
  yup
    .string()
    .trim()
    .required(REQUIRED_FIELD_MESSAGE(fieldName))
    .min(2, `${fieldName} cannot contain less than 2 letters`)
    .max(50, `${fieldName} cannot exceed 50 letters`)
    .test(
      "two-space-in-row",
      `${fieldName} cannot have more than one space in a row`,
      (value) => !TWO_SPACE_IN_ROW_REGEX.test(value)
    );

export const categoryImage = (isRequired = true) =>
  isRequired
    ? yup
        .mixed<DirectUploadMedia>()
        .required()
        .nullable()
        .test(
          "is-null",
          REQUIRED_FIELD_MESSAGE("Image"),
          (fieldValue) => !!fieldValue
        )
    : yup.mixed<DirectUploadMedia>().required().nullable();
